import { callAPI } from '../network';

export async function updateAirportsByEmployee (airports, employee ){

    //console.log(airports);
    const params = {
       airports: airports.airports.map(airport => ({
          Id: airport.Id, // Asegúrate de usar la capitalización correcta, como aparece en el objeto.
          Code: airport.Code // Igualmente aquí.
        })),
        employeeId: airports.employeeId,
        employee: employee
     };
 
    
    const data = await callAPI(
                   params, 
                         'ManagementEmployee/updateAirportsByEmployee', 'post');
    return data || [ ];
 }


 export async function getEmployeesWithAirports (companyId){
  
    const data = await callAPI(
                         null, 
                         `ManagementEmployee/getEmployeesWithAirports?companyId=${companyId}`, 'get');
    return data || [ ];
 }

 export async function getAllAirportsByEmployee(employeeId){
    let data;
       data = await callAPI(
          null, 
          'ManagementEmployee/getAirportsByEmployee?employeeId='+ employeeId, 'get');
    
   
    return data || [ ];
 }

 export async function GetAllEmployeesWithAirportsByAirport(airportId, companyId){
   const url = airportId
      ? `ManagementEmployee/GetAllEmployeesWithAirportsByAirport?companyId=${companyId}&airportId=${airportId}`
      : `ManagementEmployee/GetAllEmployeesWithAirportsByAirport?companyId=${companyId}`;
   const data = await callAPI(null, url, 'get');
   return data;
}

export async function GetAllEmployeesByAirport(airportId, companyId){
   const url = airportId
      ? `ManagementEmployee/GetAllEmployeesForEdit?companyId=${companyId}&airportId=${airportId}`
      : `ManagementEmployee/GetAllEmployeesForEdit?companyId=${companyId}`;
   const data = await callAPI(null, url, 'get');
   return data;
}

export async function deleteAirportsByEmployee (id, employee){
   const data = await callAPI(
                        null, 
                        `ManagementEmployee/deleteAirportsByEmployee?employeeId=${id}&employee=${employee}`, 'get');
   return data;
}